<template>
  <div class="goodsr_epurchase" style="min-width: 1086px">
    <!-- 数据展示 -->
    <div class="main_content" v-if="!showTaskOfficial && !showEffectAnalysis">
      <div class="global-title">
        {{ tittle }}
      </div>
      <div class="gloabal-info-box">
        <img src="@/assets/images/icon_gift.png" style="position: absolute; margin-top: 12px" />
        <span style="margin-left: 60px">{{ desc }}</span>
      </div>

      <!-- 第一个模块 tab1 -->
      <div v-if="selectIndex == 1" class="tab_item_box">
        <!-- 按钮 -->
        <div>
          <span class="create_btn3" @click="newBtn()" v-zoom="{ from: pageName + tittle, name: '状态变化' }">
            <img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 9px -6px 0px 12px;
              "
            />
            创建任务
          </span>
          <div class="right_allBtn">
            开启状态:
            <el-select v-model="search1.status" placeholder="请选择" style="width: 116px; margin-left: 8px">
              <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-input v-model="search1.activityName" placeholder="请输入任务名称" style="width: 140px; margin: 0 5px 0 8px"></el-input>
            <el-input v-model="search1.content" placeholder="请输入短信内容" style="width: 140px; margin: 0 16px 0 0"></el-input>
            <el-button icon="el-icon-search" class="status_btn" :disabled="tableLoading" @click="handleSearch1">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetBtn1">重置</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <div class="clear-float">
          <el-table
            :data="tableList"
            style="width: 100%; margin-top: 22px"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            v-loading="tableLoading"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="activityName" label="任务名称"></el-table-column>
            <el-table-column prop="content" label="短信内容" min-width="200">
              <template slot="header" slot-scope="scope">
                <span>短信内容</span>
                <span style="color:#7f85e9" @click="allShow = true" v-if="!allShow">（展开全部）</span>
                <span style="color:#7f85e9" @click="allShow = false" v-else>（收起全部）</span>
              </template>
              <template slot-scope="scope">
                <div class="hoveTitle" v-if="!allShow">
                  {{ scope.row.content | enVToChinese }}
                </div>
                <div v-else>{{ scope.row.content | enVToChinese }}</div>
              </template>
            </el-table-column>
            <el-table-column label="任务时间" width="350">
              <template slot-scope="scope">
                <span>{{ scope.row.activityStartTime }} ~ {{ scope.row.activityEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="taskStatus" label="任务状态" width="145">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.activityStatus | showStatusName }}
                  <el-tooltip class="item" v-if="scope.row.activityStatus == 4" effect="light" :content="scope.row.stopReason" placement="top-start">
                    <span class="question_icon">?</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
            <el-table-column prop="sendNum" label="已发送人数" width="80"></el-table-column>
            <el-table-column prop="feeCount" label="短信量" width="80"></el-table-column>

            <!-- <el-table-column label="开启状态" width="80">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.isOpen"
                  active-value="1"
                  active-color="#49C568"
                  inactive-value="0"
                  @change="changeSwitch(scope.row)"
                ></el-switch>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" width="380">
              <template slot-scope="scope">
                <!-- <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
                <el-button type="text" @click="delteItem(scope.row)" :style="{'color':'#f56c6c'}">删除</el-button>-->
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '查看' }"
                  @click="catchOrderCare(scope.row)"
                  type="text"
                  class="edit_btn"
                  style="width: 40px"
                  >查看</el-button
                >
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '删除' }"
                  @click="deleteOrderCare(scope.row)"
                  type="text"
                  :disabled="!(scope.row.activityStatus == 3 || scope.row.activityStatus == 4)"
                  class="del_btn"
                  style="width: 40px"
                  >删除</el-button
                >
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '停止' }"
                  @click="stopOrderCare(scope.row)"
                  :disabled="!(scope.row.activityStatus == 1 || scope.row.activityStatus == 2)"
                  type="text"
                  class="del_btn"
                  style="width: 40px"
                  >停止</el-button
                >
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '效果分析' }"
                  @click="handleEffect(scope.row)"
                  type="text"
                  class="edit_btn"
                  style="width: 65px"
                  :disabled="scope.row.taskCount === 0"
                  >效果分析</el-button
                >
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '营销记录' }"
                  @click="handleMarketingRecord(scope.row)"
                  type="text"
                  class="edit_btn"
                  style="width: 65px"
                  :disabled="scope.row.activityStatus == 1"
                  >营销记录</el-button
                >
                <el-button @click="handlecopon(scope.row)" type="text" class="edit_btn">复制</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <pagination
          @transferName="smsPaginationFunction"
          :total="taskTableTotalCount"
        ></pagination> -->
        <div>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search1.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="search1.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="taskTableTotalCount"
          ></el-pagination>
        </div>
      </div>
      <!-- 第二个模块 tab2 -->
    </div>

    <!-- 营销记录弹窗 -->
    <market-record-dialog v-if="visible" :propId="propId" @onClose="closeRecordDialog"></market-record-dialog>

    <!-- 效果分析页面 -->
    <effect-analysis v-if="showEffectAnalysis" :officialObj="officialObj" @onClose="handleCloseEffect"></effect-analysis>

    <!-- 创建活动 -->
    <create-task-official
      @onClose="handleCloseTask"
      v-if="showTaskOfficial"
      :activityType="search1.activityType"
      :detailObj="detailObj"
      :copyIsfaly="copyIsfaly"
    ></create-task-official>
  </div>
</template>

<script>
import { mapState } from "vuex";
import topTitle from "@/components/top-title.vue";
import Pagination from "@/components/pagination.vue";
import marketRecordDialog from "@/components/marketing-record-dialog.vue";
// import pageCondition from "./autoMarket/page-condition.vue";
// import sendMessageX from "@/components/send-message-x.vue";
import { getActivityList, deleteMarket, stopActivity, catchActivity } from "@/api/marketing/autoMarketingO";
import effectAnalysis from "@/components/effect-analysis-x.vue";
import createTaskOfficial from "@/components/create-task-official.vue";
// import pageConditionX from "@/components/page-condition-x.vue";

export default {
  components: {
    topTitle,
    Pagination,
    // pageCondition,
    marketRecordDialog,
    // sendMessageX,
    effectAnalysis,
    createTaskOfficial,
    // pageConditionX
  },
  data() {
    return {
      copyIsfaly: false,
      pageName: "客户营销-自动化营销（官方）",
      officialObj: {}, // 效果分析传参
      detailObj: {},
      propId: "", // 营销记录id
      showEffectAnalysis: false,
      selectEffectObj: {},
      typeEffect: 4,

      selectIndex: 1,
      tableState: true,
      tableLoading: false,
      talbeLoading1: false,
      allShow: false, // 信息是否全部显示
      smsTableTotalCount: 0,
      taskTableTotalCount: 10,
      // topPX: "60px",
      // bodyHeight: 0,
      // detailFormData: null, // 编辑任务获取详情数据
      // pageConditionCom: false, //编辑新建任务组件
      search1: {
        content: "",
        status: "",
        activityName: "",
        size: 10,
        current: 1,
        activityType: 1,
      },
      // 首购有礼查询条件
      smsSearchParams: {
        sendStartTime: "", //发送开始时间
        sendEndTime: "", //发送结束时间
        // comfrom: "", //信息来由
        buyerNick: "", //买家昵称
        mobile: "", //手机号码
        status: "", //发送状态 0未发送 1已发送 2黑名单失败 4(10分钟内容重复) 3过滤重复发送 5无效号码 6中差评拦截 7退款拦截 ,
        tid: "", //订单编号
        // softType: "1", //1(订单关怀,掌柜预警) 2(会员营销)
        content: "", //短信内容
        pageNum: 1, //当前页
        pageSize: 10, //每页大小
        total: "",
      },
      // 发送状态
      stateList: [
        {
          value: "",
          label: "-全部-",
        },
        {
          value: "1",
          label: "未开始",
        },
        {
          value: "2",
          label: "进行中",
        },
        {
          value: "3",
          label: "已结束",
        },
        {
          value: "4",
          label: "已停止",
        },
      ],
      // 表格数据
      smsTableList: [],
      tableList: [],
      /**
       * 主页记录分页信息
       */
      paginationInfo: {
        tableCurrentPage: 1,
        pageSize: 10,
        totalCount: 100,
      },
      crowdTotal: 10,
      visible: false,
      showTaskOfficial: false,
    };
  },
  mounted() {
    console.log(this.copyIsfaly, 66666);
    this.handleSearch();
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),

    // 获取定义在路由meta的信息
    tittle() {
      var name = "";
      if (this.$route.meta.itemIndex == "1") {
        name = "首购有礼";
      } else if (this.$route.meta.itemIndex == "2") {
        name = "复购提醒";
      } else if (this.$route.meta.itemIndex == "3") {
        name = "流失客户召回";
      } else if (this.$route.meta.itemIndex == "4") {
        name = "兴趣客户转化";
      } else if (this.$route.meta.itemIndex == "5") {
        name = "开卡未购会员转化";
      }
      // console.log(name,this.pageName)
      return name;
    },
    desc() {
      return this.$route.meta.desc;
    },
    MenuIndex() {
      return this.$route.meta.itemIndex;
    },
  },
  filters: {
    // taskTypeStr(taskType) {
    //   return { 1: "指定时间", 0: "持续开启" }[taskType];
    // },
    showStatusName(status) {
      var res = "";
      if (status) {
        var list = ["", "未开始", "进行中", "已结束", "已停止"];
        res = list[status];
      }
      return res;
    },

    statusStr(status) {
      return {
        0: "未发送",
        1: "已发送",
        2: "黑名单失败",
        4: "10分钟内容重复",
        3: "过滤重复发送",
        5: "无效号码",
        6: "中差评拦截",
        7: "退款拦截",
      }[status];
    },
  },
  methods: {
    handlecopon(row) {
      catchActivity(row.id).then((res) => {
        this.detailObj = { ...res.data, activityEndTime: "", activityStartTime: "" };
        this.showTaskOfficial = true;
        this.copyIsfaly = true;
      });
      // this.copyItem = item;
    },
    handleSizeChange(val) {
      this.search1.size = val;
      this.search1.current = 1;

      this.handleSearch();
    },

    handleCurrentChange(val) {
      this.search1.current = val;
      this.handleSearch();
    },
    handleCloseTask(val) {
      this.showTaskOfficial = false;
      if (val && val.refresh) {
        this.handleSearch();
      }
    },
    // 查看按钮
    catchOrderCare(row) {
      catchActivity(row.id).then((res) => {
        this.detailObj = res.data;
        this.showTaskOfficial = true;
        this.copyIsfaly = false;
      });
    },
    handleCloseEffect() {
      this.showEffectAnalysis = false;
    },
    // 查询接口
    handleSearch() {
      this.tableLoading = true;
      // console.log("1111111111")
      this.search1.activityType = this.MenuIndex;
      getActivityList(this.search1).then((res) => {
        this.tableLoading = false;
        this.tableList = res.data.records;
        this.taskTableTotalCount = res.data.total;
      });
    },
    handleSearch1() {
      this.search1.current = 1;
      this.handleSearch();
    },
    // 停止活动
    stopOrderCare(row) {
      this.$confirm("你是否确认停止执行这项任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          stopActivity(row.id).then((res) => {
            if (res.code == "1") {
              this.$message.success("停止成功！");
              this.handleSearch();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // this.$message.info("已取消停止");
        });
    },
    // 删除活动
    deleteOrderCare(row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          var fid = row.id;
          deleteMarket(fid).then((res) => {
            if (res.code == "1") {
              this.$message.success("删除成功！");
              this.handleSearch();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    closeRecordDialog() {
      console.log("closeRecordDialog");
      this.visible = false;
    },
    handleMarketingRecord(row) {
      // 营销记录记录弹窗
      this.propId = row.id + "";
      this.visible = true;
    },
    handleEffect(row) {
      // 跳转营销效果分析页面
      // row.activityEndTime = row.activityEndTime.split(" ")[0];
      // row.activityStartTime = row.activityStartTime.split(" ")[0];
      // console.log(row);
      // return
      // this.selectEffectObj = row;

      this.officialObj = {
        outerId: row.id,
        source: "AUTO_MARKETING",
        activityEndTime: row.activityEndTime.split(" ")[0],
        activityStartTime: row.activityStartTime.split(" ")[0],
      };

      this.showEffectAnalysis = true;
    },
    smsPaginationFunction(event) {
      this.smsSearchParams.pageNum = event.current;
      this.smsSearchParams.pageSize = event.pageSize;
      this.getMessageRecord();
    },
    clearTime() {
      this.smsSearchParams.sendStartTime = "";
      this.smsSearchParams.sendEndTime = "";
    },
    resetBtn1() {
      this.search1 = {
        content: "",
        activityName: "",
        status: "",
        size: 10,
        current: 1,
        activityType: "",
      };
      this.handleSearch();
    },
    newBtn() {
      this.detailObj = {};
      this.showTaskOfficial = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.question_icon {
  width: 14px;
  height: 14px;
  color: #e67474 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #e67474;
  font-size: 12px !important;
  font-weight: normal !important;
}
.is-disabled.el-button {
  color: #ddd !important;
}
// .top_content {
// background: rgba(255, 255, 255, 1);
// box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
// opacity: 1;
// border-radius: 6px;
// margin: 11px 20px 20px 20px;
// }
.main_content {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 20px;

  // padding-top: 20px;
  // .tab_all {
  //   border-bottom: 1px solid #f6f6f6;
  //   margin-bottom: 20px;
  //   .tab_item {
  //     font-size: 14px;
  //     // font-family:PingFang SC;
  //     font-weight: 400;
  //     line-height: 20px;
  //     color: rgba(153, 153, 153, 1);
  //     opacity: 1;
  //     margin-right: 22px;
  //     padding: 15px 0px;
  //     display: inline-block;
  //     cursor: pointer;
  //   }
  //   .active {
  //     border-bottom: 2px solid #fe4d45;
  //     color: #fe4d45;
  //   }

  // }
  .create_btn3 {
    width: 98px;
    height: 32px;
    opacity: 1;
    border-radius: 3px;
    display: inline-block;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
  .right_allBtn {
    float: right;
    // margin-right: 28px;
    color: #333;
    font-size: 14px;
  }
  .tab_item_box {
    padding: 0px 25px 30px;
    .status_btn {
      font-size: 14px;
      width: 98px;
      font-size: 14px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .status_btn2 {
      margin-left: 8px;
      color: #666666;
      font-size: 14px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .search_item {
      display: inline-block;
      margin-right: 79px;
      margin-bottom: 16px;
      color: #333;
    }
  }
  .edit_btn {
    color: #7f85e9;
    font-size: 14px;
    width: 38px;
    padding: 0px !important;
    border: 0px;
    height: 20px;
    line-height: 20px;
    margin-left: 0;
    // margin-right: 20px;
  }
  .del_btn {
    font-size: 14px;
    padding: 0px !important;
    border: 0px;
    height: 20px;
    line-height: 20px;
    color: #fe4d45;
    margin-left: 0px;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 18px;
}
</style>
